export const LISTE_SERVICE = {
  title: 'Liste des services',
  breadcrumb: {
    liste: 'Liste des services',
  },
  actions: {
    add: 'Nouveau service',
  },
  tab: {
    code: 'Code',
    nom: 'Raison sociale',
    adresse: 'Adresse',
    ville: 'Ville',
    cp: 'CP',
    telephone: 'Téléphone',
    portable: 'Portable',
    email: 'Email',
    codeComptable: 'Code comptable',
    archive: 'Archivé',
    actions: {
      edit: 'Modifier',
      delete: 'Supprimer',
      archive: 'Archiver',
    },
  },
  filtre: {
    service: 'Service',
    archive: 'Archivé',
  },
  archivage: {
    titleDesarchiver: 'Êtes-vous sûr de vouloir désarchiver ce service ?',
    title: 'Êtes-vous sûr de vouloir archiver ce service ?',
    sucessArchivage: 'Service archivé avec succès',
    sucessDesarchivage: 'Service désarchivé avec succès',
  },
};

export const EDITION_SERVICE = {
  titleCreation: 'Création service',
  titleModification: 'Modification service {libelle}',
};
